import React, { Dispatch, SetStateAction } from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { generateResponsiveStyle } from '../utils/modalStyle';

interface props {
  openLogout: boolean;
  setOpenLogout: Dispatch<SetStateAction<boolean>>;
  handleLogout: () => void;
}

const LogoutModal = ({ openLogout, setOpenLogout, handleLogout }: props) => {
  const style = generateResponsiveStyle();

  return (
    <Modal
      open={openLogout}
      onClose={() => setOpenLogout(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="modal_body logout_body">
          <CloseIcon className="cross_icn_logout" onClick={() => setOpenLogout(false)} />
          <Typography id="modal-modal-title" component="h2">
            Are you sure, you want to logout?
          </Typography>
          <div className="form_btn">
            <Button
              className="btn btn_primary"
              onClick={() => {
                setOpenLogout(false);
                handleLogout();
              }}
            >
              Yes
            </Button>
            <Button className="btn btn_secondary" onClick={() => setOpenLogout(false)}>
              No
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default LogoutModal;
